<script>
// import VueVideoPlayer from "../components/vueVideoPlayer.vue";
// import ScrollContent from "../../../family-photo2/views/components/scrollContent.vue";
// import ScrollXContent from "../components/scrollXContent.vue";
import traceFunction from "../components/trace-function";
import _ from 'lodash'
// console.log(gsap, ScrollTrigger)

export default {
  name: "story0",
  components: {},
  props: {
    // imageUrl: {
    //   type: String,
    //   default: 'https://hbrbapp.hubeidaily.net/h5/family-photo/01%20%281%29.png'
    // },
    // btnImage: {},
    // fuImageUrl: {
    //   type: String,
    //   default: 'https://hbrbapp.hubeidaily.net/h5/family-photo/%E5%8D%A1%E9%80%9A%E7%A6%8F.png'
    // },
    index: {},
    btnImageUrl: {},
    videoUrl: {},
    videoPostUrl: {},
    photoImageUrl: {},
    backgroundImageUrl: {},
    fuImageUrl: {},
    photoPosition: {},
    areaInfo: {},
    photoTop: {},
    photoHeight: {},
    photoMaskPosition: {},
    postToTop: {},
    fuImageScale: {},
    firstPathList: [],
    secondPathList: [],
    gsap: {}
  },
  data () {
    return {
      showVideo: false,
      showVideoBtn: false,
      colorStop: 0,
      // showSlideImage: false,
      transparentStop: 0
    }
  },
  mounted () {

  },
  watch: {
    showVideoBtn (val) {
      this.$emit('btn-show-change', val)
    },
    showVideo (val) {
      if (!val) {
        this.$emit('stop-video')
      }
    }
  },
  computed: {
    storyPathList () {
      const path1 = _.cloneDeep(this.firstPathList)
      const path2 = _.cloneDeep(this.secondPathList)
      path1.push(this.photoPosition)
      path2.unshift(this.photoPosition)
      return [{
        category: 'start',
        path: path1
      }, {
        category: 'end',
        path: path2
      },
      ]
    }
  },
  methods: {
    imageFallen () {
      const gsap = this.gsap
      const elementName = '.fu-image'
      // const positions = [
      //   {
      //     x: 5,
      //     y: 263
      //   },
      //   {
      //     x: 55,
      //     y: 475
      //   }
      // ]
      // const photoPosition =  {
      //   x: 67,
      //   y: 492
      // }
      const storyPath = this.storyPathList
      const adjustment = {
        x: 17,
        y: 18
      }
      // console.log(storyPath)
      if (this.index === 0) {
        const firstPosition = storyPath[0].path[0]
        gsap.set(".fu-image",{
          opacity: 0,
          scale: 0,
          x: (firstPosition.x - adjustment.x) + 'vw',
          y: (firstPosition.y - adjustment.y) + 'vw',
        })
      }
      const timeline = gsap.timeline()
      storyPath.forEach(pathInfo => {
        if (pathInfo.category === 'start') {
          this.initPath(timeline, gsap, pathInfo.path, adjustment, elementName, pathInfo.category, `.first-area${this.index}`)
        } else if (pathInfo.category === 'end') {
          if (this.index !== -1) {
            this.initPath(timeline, gsap, pathInfo.path, adjustment, elementName, pathInfo.category, `.photo-to-manga${this.index}`, `.manga-photo${this.index}`)
          }
        }
      })
    },
    initPath (
        timeline,
        gsap,
        pathList,
        adjustment,
        elementName,
        category,
        trigger,
        videoPostClass=''
    ) {
      let points = []
      for (let i = 0; i < pathList.length - 1; i++) {
        points = points.concat(traceFunction.generateCatmullRomPoints(
            pathList[i], pathList[i + 1],50
        ).slice(0, 50))
      }
      // console.log(points)
      const keyframes = _.map(points, position => {
        return {
          x: (position.x - adjustment.x) + 'vw',
          y: (position.y - adjustment.y) + 'vw',
        }
      })
      // console.log(keyframes)
      // 间隔的距离
      const vwDistance = window.innerWidth / 100
      const intervalVwDistance = pathList[pathList.length - 1].y - pathList[0].y
      const intervalArea = 20
      const topVm = 50
      if (category === 'start') {
        // 放大
        this.addScrollToTimeLine(
            timeline,
            gsap,
            this.index === 0 ?`center center` : `bottom center`,
            this.index === 0 ?`bottom center` : `top top`,
            elementName,
            { scale: this.fuImageScale, opacity: 1 },
            trigger,
            '.main-page',
            false
        )
      }
      // 下落
      // console.log(keyframes)
      if (category === 'start') {
        this.addScrollToTimeLine(
            timeline,
            gsap,
            this.index === 0 ? `center top+=${topVm * vwDistance}px` : 'top top',
            this.index === 0 ? `top+=${intervalVwDistance * vwDistance}px center` : `center+=${intervalVwDistance * vwDistance}px center`,
            elementName,
            { keyframes: keyframes },
            trigger,
            '.main-page',
            false
        )
      } else {
        this.addScrollToTimeLine(
            timeline,
            gsap,
            `center top+=${topVm * vwDistance}px`,
            `center+=${intervalVwDistance * vwDistance}px bottom`,
            elementName,
            { keyframes: keyframes },
            trigger,
            '.main-page',
            false
        )
      }
      // 切换
      if (category === 'start') {
        this.addScrollToTimeLine(
            timeline,
            gsap,
            this.index === 0 ? `center+=${(intervalVwDistance) * vwDistance}px center` : `bottom+=${(intervalVwDistance) * vwDistance}px center`,
            this.index === 0 ? `center+=${(intervalVwDistance + intervalArea * 2.5) * vwDistance}px center` : `bottom+=${(intervalVwDistance + intervalArea * 2.5) * vwDistance}px center`,
            elementName,
            { opacity: 1 },
            trigger,
            '.main-page',
            false,
            (self) => {
              // console.log(self.progress)
              this.onscroll(self.progress)
            }
        )
      } else {
        if (this.index === -1) {
          return
        }
        this.addScrollToTimeLine(
            timeline,
            gsap,
            `center+=${(intervalVwDistance) * vwDistance - intervalArea}px bottom`,
            `center+=${(intervalVwDistance + intervalArea * 2) * vwDistance}px bottom`,
            elementName,
            { opacity: 0 },
            trigger,
            '.main-page',
            false,
            (self) => {}
        )
        this.addScrollToTimeLine(
            timeline,
            gsap,
            `bottom bottom`,
            `top top`,
            elementName,
            {},
            videoPostClass,
            '.main-page',
            false,
            (self) => {
              // console.log(self.progress)
            }, () => {
              this.showVideoBtn = true
            }, () => {
              this.showVideoBtn = false
              this.showVideo = false
            }, () => {
              this.showVideoBtn = true
            }, () => {
              this.showVideoBtn = false
              this.showVideo = false
            }
        )
      }
    },
    addScrollToTimeLine (
        timeline,
        gsap,
        start,
        end,
        elementName,
        attribute,
        trigger,
        scroller,
        markers=false,
        onUpdate = () => {},
        onEnter = () => {},
        onLeave = () => {},
        onEnterBack = () => {},
        onLeaveBack = () => {}
    ) {
      const currentTimeline = gsap.timeline({
        scrollTrigger: {
          start,
          end,
          trigger,
          scrub: true,
          markers,
          scroller,
          onUpdate: (self) => {
            onUpdate(self)
          },
          onEnter: (self) => {
            onEnter()
          },
          onLeave: (self) => {
            onLeave()
          },
          onEnterBack: () => {
            onEnterBack()
          },
          onLeaveBack: () => {
            onLeaveBack()
          }
        }
      })
      currentTimeline.to(elementName, attribute)
      timeline.add(currentTimeline)
    },
    testFuImageFallen () {
      const gsap = this.gsap
      const elementName = '.fu-image'
      const positions = [
        {
          x: 2.5,
          y: 260
        },
        {
          x: 30,
          y: 530
        }
      ]
      const firstPosition = positions[0]
      const timeline = gsap.timeline()
      gsap.set(elementName,{
        opacity: 0,
        scale: 0.5,
        x: firstPosition.x + 'vw',
        y: firstPosition.y + 'vw',
      })

      timeline.to(elementName,{
        opacity: 1,
        scale: 1,
        duration: 2
      })
      const keyframes = this.getKeyframesList(positions)
      timeline.to(elementName, {
        keyframes: keyframes[0],
        duration: 5
      })
      timeline.to(elementName,{
        opacity: 0,
        scale: 0.5,
      })
    },
    getKeyframesList (positions, adjustment) {
      const keyframesList = []
      keyframesList.push(_.map(positions, position => {
        return {
          x: position.x - adjustment.x + 'vw',
          y: position.y - adjustment.y + 'vw',
        }
      }))
      return keyframesList
    },
    onPause () {
      this.$emit('pause-video')
    },
    onPlay () {
      this.$emit('play-video')
    },
    onEndedPlay () {
      this.showVideo = false
    },
    clickPhotoToImage () {
      this.showVideo = true
      this.$nextTick(() => {
        this.$refs.videoPlayer.play()
      })
    },
    onscroll (rate) {
      console.log(rate, 'onScroll')
      this.colorStop = rate * 100
      this.transparentStop = Math.min(rate * 100 * 1.8, 100)
    },
    onBackgroundClick (event) {
      this.$emit('background-click', event)
    }
  }
}
</script>

<template>
  <div class="background" @click="onBackgroundClick">
    <img class="background-image" :src="backgroundImageUrl">
    <div :class="`photo-to-manga photo-to-manga${index}`" :style="{top: photoTop + 'vw', height: photoHeight + 'vw'}">
      <div class="photo-to-manga-box">
        <div class="photo-to-manga-mask" :style="{
          // 'mask': `linear-gradient(-45deg, #000 ${colorStop}%, transparent ${transparentStop}%, transparent)`
          //  'mask': `radial-gradient(circle at 70% 15%, rgba(0, 0, 0, 0) ${colorStop}%, rgba(0, 0, 0, 1) ${transparentStop}%)
          'background-image': `url('${photoImageUrl}')`,
          'mask': `radial-gradient(circle at ${photoMaskPosition}, rgb(0, 0, 0) ${colorStop}%, rgba(0, 0, 0, 0) ${transparentStop}%)`
        }"></div>
<!--        <scroll-x-content class="photo-to-manga-scroll-container" @scroll="onscroll">-->
<!--          <div style="font-size: 2rem" class="photo-to-manga-scroll-content"></div>-->
<!--        </scroll-x-content>-->
      </div>
    </div>
    <div :class="`manga-photo manga-photo${index}`" :style="{bottom: postToTop + 'vw'}">
      <div class="manga-video" v-if="showVideo">
        <video
            ref="videoPlayer"
            class="manga-video-player"
            controls=""
            :src="videoUrl"
            @ended="onEndedPlay"
            @play="onPlay"
            @pause="onPause"
            playsinline=""
            x-webkit-airplay=""
            webkit-playsinline=""
            x5-playsinline=""
        ></video>
<!--        <vue-video-player @ended="onEndedPlay" ref="videoPlayer" class="manga-video-player" :video-url="videoUrl"></vue-video-player>-->
      </div>
      <div class="manga-photo-image" :style="`background-image: url('${videoPostUrl}');`" v-if="!showVideo" @click.prevent>
        <div  v-if="showVideoBtn" @click="clickPhotoToImage" class="play-btn" >
          <img :src="btnImageUrl" style="width: 100%">
        </div>
      </div>
    </div>
    <div
      :class="`first-area${index}`"
      :style="{
        position: 'absolute',
        width: '100vw',
        height: areaInfo.height + 'vw',
        top: areaInfo.top + 'vw',
        left: '0'
      }"
    >
    </div>
  </div>
</template>

<style scoped lang="scss">
.background {
  width: 100%;
  position: relative;
  //height: 100%;
}
.background-image {
  width: 100%;
  display: block;
}
.manga-photo {
  width: 100%;
  height: 67vw;
  position: absolute;
  //bottom: 7vw;
}
.manga-photo-image {
  width: 100%;
  height: 100%;
  //background-position: center -240vh;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
}
.manga-video-player {
  margin-top: 5vw;
  width: 100%;
  height: 100%;
  z-index: 9999;
  position: relative;
}
.slide-image {
  position: absolute;
  width: 30vw;
  bottom: 5%;
  right: 40%;
  z-index: 10;
}
.play-btn {
  width: 15%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
}
.photo-to-manga {
  position: absolute;
  width: 100%;
  height: 79vw;
}
.photo-to-manga-box {
  position: relative;
  width: 100%;
  height: 100%;
}
.photo-to-manga-scroll-container {
  width: 100%;
  height: 100%;
  //background: red;
  position: absolute;
  //overflow-x: scroll;
}
.photo-to-manga-scroll-content {
  width: 200vw;
  overflow: hidden;
  //background: red;
  height: 100%;
}
.photo-to-manga-mask {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-size: cover;
  background-position: 54%;
}
.slide-image-animation {
  animation: shakeX;
  animation-duration: 3s;
  animation-iteration-count: infinite;
}

</style>